import { Link, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Building2 } from 'lucide-react';

// Portal customer accounts are also managed by ctOneAuth. We send the user
// off to register/sign in there, and bring them back to the join flow
// (with their join code, if one was provided in the URL).
export default function PortalRegister() {
  const { loginWithOIDC } = useAuth();
  const [searchParams] = useSearchParams();
  const codeFromUrl = searchParams.get('code') || '';

  const returnTo = codeFromUrl ? `/portal/join/${codeFromUrl}` : '/portal/join';

  return (
    <div
      className="flex items-center justify-center px-4"
      style={{ minHeight: '100vh', background: 'var(--scpa-bg)' }}
    >
      <div className="card w-full max-w-sm">
        <div className="flex items-center justify-center gap-2.5 mb-6">
          <div className="w-8 h-8 rounded-lg brand-gradient flex items-center justify-center">
            <Building2 className="w-4 h-4 text-white" />
          </div>
          <span className="font-semibold text-fg tracking-tight">
            Customer <span className="brand-gradient-text font-bold">Portal</span>
          </span>
        </div>

        <h1 className="text-xl font-semibold text-fg mb-1">
          Create your account
        </h1>
        <p className="text-sm text-muted mb-6">
          Accounts are managed by ctOneAuth. You'll be redirected to sign up, then
          brought back to the portal{codeFromUrl ? ' to join with your code.' : '.'}
        </p>

        <button
          type="button"
          onClick={() => loginWithOIDC(returnTo)}
          className="btn btn-primary w-full"
        >
          Continue to ctOneAuth
        </button>

        <p className="mt-4 text-center text-sm text-muted">
          Already have an account?{' '}
          <Link to="/login" className="text-primary hover:underline">Sign in</Link>
        </p>
        <p className="mt-2 text-center text-sm text-muted">
          Are you a business?{' '}
          <Link to="/register" className="text-primary hover:underline">Register your company</Link>
        </p>
      </div>
    </div>
  );
}
